<template>
  <div class="EventPage">
    <UIEventsDetailPage
      v-if="eventData"
      id="main"
      :event="eventData"
    />
    <ElocusPage v-else />
  </div>
</template>

<script setup lang="ts">
  import type { EventItem } from '@tc8l/nuxt-overview'

  definePageMeta({
    alias: ['/en/events/:slug', '/nl/events/:slug'],
  })

  const route = useRoute()

  const { data: eventData } = await useBaseAsyncData<EventItem>('/events/' + route.params.slug)
</script>
